var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    })
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.527 77.594l-8.32-13.398 8.32-13.41 4.012 13.41zm-18.516-1.305l-10.453-9.93h16.637l8.32 13.402zm0-24.238l14.465-3.473-8.32 13.41H9.516zM41.258 42l-18.902 4.699-2.812 4.621-5.676-.043L0 64.195l13.867 12.914 5.676-.043 2.813 4.617 18.902 4.742 5.078-17.617-2.859-4.574 2.859-4.578zM84.18 55.039c-2.516 0-4.223 1.02-5.504 2.902h-.082v-2.414h-4.437v17.734h4.52V63.207c0-2.406 1.582-4.086 3.758-4.086 2.047 0 3.582 1.188 3.582 3.273v10.91h4.523V61.699c.043-3.883-2.52-6.66-6.359-6.66zM67.285 65.781c0 2.375-1.406 4.008-3.711 4.008-2.09 0-3.414-1.145-3.414-3.223V55.527h-4.523v11.852c0 3.883 2.305 6.418 6.441 6.418 2.605 0 4.055-.941 5.293-2.578h.129v2.086h4.352V55.527h-4.523v10.254zm25.688-10.254h4.52v17.734h-4.52zm0-5.516h4.52v3.555h-4.52zm30.164 5.516l-2.687 8.012c-.598 1.633-1.066 3.883-1.066 3.883h-.129l-1.195-3.883-3.031-8.012h-4.863l4.992 12.629c1.066 2.699 1.41 3.84 1.41 4.82 0 1.473-.812 2.414-2.73 2.414h-1.75v3.719h2.902c3.754 0 5.074-1.43 6.484-5.355L128 55.57h-4.863zm-17.195 12.547v-9.402h2.902V55.57h-2.902v-5.559h-4.523v5.516H98.86v3.105h2.559v10.422c0 3.348 2.645 4.25 5.035 4.25l2.477-.082v-3.434h-1.152c-1.066.039-1.836-.406-1.836-1.715zm0 0",
    fill: "#110B09"
  }));
};